@switch (bonus) {
    @case (0) {
    <span></span>
    }
    @case (50) {
    <span>&nbsp;&nbsp;<img src="assets/images/svg/recruiter-bonus/50.svg" alt="50" class="recruiter-bonus" /></span>
    }
    @case (100) {
    <span><img src="assets/images/svg/recruiter-bonus/100.svg" alt="100" class="recruiter-bonus" /></span>
    }
    @case (150) {
    <span><img src="assets/images/svg/recruiter-bonus/150.svg" alt="150" class="recruiter-bonus" /></span>
    }
    @case (200) {
    <span><img src="assets/images/svg/recruiter-bonus/200.svg" alt="200" class="recruiter-bonus" /></span>
    }
    @case (250) {
    <span><img src="assets/images/svg/recruiter-bonus/250.svg" alt="250" class="recruiter-bonus" /></span>
    }
    @case (300) {
    <span><img src="assets/images/svg/recruiter-bonus/300.svg" alt="300" class="recruiter-bonus" /></span>
    }
    @case (350) {
    <span><img src="assets/images/svg/recruiter-bonus/350.svg" alt="350" class="recruiter-bonus" /></span>
    }
    @case (400) {
    <span><img src="assets/images/svg/recruiter-bonus/400.svg" alt="400" class="recruiter-bonus" /></span>
    }
    @case (450) {
    <span><img src="assets/images/svg/recruiter-bonus/450.svg" alt="450" class="recruiter-bonus" /></span>
    }
    @case (500) {
    <span><img src="assets/images/svg/recruiter-bonus/500.svg" alt="500" class="recruiter-bonus" /></span>
    }
    @case (550) {
    <span><img src="assets/images/svg/recruiter-bonus/550.svg" alt="550" class="recruiter-bonus" /></span>
    }
    @case (600) {
    <span><img src="assets/images/svg/recruiter-bonus/600.svg" alt="600" class="recruiter-bonus" /></span>
    }
    @default {
    <span>{{bonus | currency:'USD'}}</span>
    }
}